import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import { urls } from '@/constants';

import ConsumeRedirectRoute from '@/components/Navigation/ConsumeRedirectRoute';

import DashboardPage from './DashboardPage';

const Dashboard: React.FC = () => (
  <Switch>
    <Route exact path={urls.dashboard} component={DashboardPage} />
    <ConsumeRedirectRoute render={() => <Redirect to={urls.locations.list} />} />
  </Switch>
);

export default Dashboard;
